import styled, { css } from 'styled-components';
import { AssetStatusOptions } from '@models/OnboardingAsset.model';

export const RequestStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 9px;
`;

export const RequestStatusBadge = styled.span`
  padding: 6px;
  border-radius: 100%;

  ${(props: { $status: AssetStatusOptions }) => {
    if (props.$status === 'inventory' || props.$status === 'matched') {
      return css`
        background: #1371fe;
      `;
    }

    if (props.$status === 'nonMatched' || props.$status === 'discarded') {
      return css`
        background: #ff9900;
      `;
    }

    return css`
      background: #d14343;
    `;
  }}
`;

export const RequestStatusTag = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #7380c0;
  text-overflow: ellipsis;

  ${(props: { $status?: AssetStatusOptions }) =>
    props.$status === 'matched' &&
    css`
      color: #1371fe;
    `}
`;
